import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A192F]">
        <Loader2 className="text-[#D4AF37] animate-spin" size={32} />
      </div>
    );
  }
  if (user) {
    const dest = location.state?.from?.pathname || "/admin";
    return <Navigate to={dest} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const r = await login(email.trim(), password);
    setSubmitting(false);
    if (!r.ok) setError(r.error);
  };

  return (
    <div className="min-h-screen bg-[#0A192F] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-[#D4AF37]">
            <Lock className="text-[#0A192F]" size={22} />
          </div>
          <h1 className="mt-6 font-display font-black text-3xl text-white tracking-tighter">
            CM Lindley Admin
          </h1>
          <p className="mt-2 text-white/60 text-sm font-display uppercase tracking-[0.3em]">
            Sign In
          </p>
        </div>

        <form onSubmit={onSubmit} className="bg-white p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="font-display text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/70 font-semibold">
              Email
            </label>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-2 w-full bg-white border border-gray-300 px-4 py-3 text-[#0A192F] focus:border-[#D4AF37] focus:outline-none transition-colors"
            />
          </div>
          <div>
            <label className="font-display text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/70 font-semibold">
              Password
            </label>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-2 w-full bg-white border border-gray-300 px-4 py-3 text-[#0A192F] focus:border-[#D4AF37] focus:outline-none transition-colors"
            />
          </div>
          {error && (
            <div data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#0A192F] text-white px-6 py-4 font-display text-xs uppercase tracking-[0.3em] font-bold hover:bg-[#D4AF37] hover:text-[#0A192F] transition-colors disabled:opacity-60"
          >
            {submitting ? (
              <>
                <Loader2 size={14} className="animate-spin" /> Signing in…
              </>
            ) : (
              <>Sign In</>
            )}
          </button>
        </form>

        <p className="mt-6 text-center text-white/40 text-xs">
          Authorized personnel only. Contact your administrator for credentials.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
